import React, { useState } from 'react';
import {
    Midi
} from '@tonejs/midi';
import { RydProject } from '../../model/project';
import { RydToggleButton } from '../widgets/RydToggleButton';

import './RydMidiLoadDialog.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX } from '@fortawesome/free-solid-svg-icons';
import { convertMidiToRydProject } from '../../utils/RydMidiConverter';


export function RydMidiLoadDialog({
    setProject
}: {
    setProject: (project: RydProject) => void
}) {
    const [midi, setMidi] = useState<Midi>();
    const [error, setError] = useState('');
    const [includedTracks, setIncludedTracks] = useState<number[]>([]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const arrayBuffer = event.target?.result;
            if (!(arrayBuffer instanceof ArrayBuffer)) return;

            try {
                const midi = new Midi(arrayBuffer);
                console.log('Parsed MIDI:', midi);
                setMidi(midi);
                // initially include all tracks that have notes
                setIncludedTracks(midi.tracks.map((t, index) => {
                    return {
                        index,
                        include: t.notes.length > 0
                    }
                }).filter(t => t.include).map(t => t.index)
                );
            } catch (e) {
                setError('Error parsing the MIDI file.');
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const importMidi = () => {
        const project = convertMidiToRydProject({ midi, includedTracks });

        setIncludedTracks([]);
        setMidi(undefined);
        setError('');

        setProject(project);
    };

    return (
        <div className="ryd-midi-load-dialog">
            {error && <p className="error">{error}</p>}
            <input type="file" accept=".mid,.midi" onChange={handleFileChange} />

            {midi &&
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    // alignItems: 'left',
                    marginTop: '10px'
                }}>
                    <h3>Tracks</h3>
                    <table>
                        <thead>
                            <tr>
                                <th className='first'>#</th>
                                <th className='second'>Name</th>
                                <th className='third'>Inst</th>
                                <th className='fourth'>Inc</th>
                            </tr>
                        </thead>
                        <tbody>
                            {midi.tracks.map((track, index) => {
                                const included = track.notes.length > 0 && includedTracks.includes(index);
                                return (
                                    <tr key={index}>
                                        <td className='first'>{index}</td>
                                        <td className='second'>{track.name ? track.name : `Track ${index + 1}`}</td>
                                        <td className='third'>{track.instrument.name}, {track.instrument.number}, {track.notes.length}</td>
                                        <td className='fourth'>
                                            <RydToggleButton
                                                active={included}
                                                onActivate={() => {
                                                    setIncludedTracks([...includedTracks, index]);
                                                }}
                                                onDeactivate={() => {
                                                    setIncludedTracks(includedTracks.filter(i => i !== index));
                                                }}
                                                activeStyle={{ backgroundColor: 'lightgreen' }}
                                                inactiveStyle={{ backgroundColor: 'lightgray' }}
                                            >
                                                {included
                                                    ? <FontAwesomeIcon icon={faCheck} />
                                                    : <FontAwesomeIcon icon={faX} />
                                                }
                                            </RydToggleButton>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <button
                        onClick={importMidi}
                    >Import</button>
                    <button onClick={() => setMidi(undefined)}>Cancel</button>
                </div>
            }
        </div>
    );
}
